import React, { useEffect, useState, useRef } from "react";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { primary, url } from "../../urlConfig";
import CardList2 from "../../Components/Shimmer/card2";
import Lines from "../../Components/Shimmer/Lines";
import CardList from "../../Components/Shimmer/Cards";
import Cookies from "js-cookie";
import AttractionCard from "../../Components/Attractions/AttractionCard";
import AllCuisines from "../../Components/cuisines";
import LatestBlogs from "../../Components/LatestBlogs";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../Components/Footer";
import NavBar from "../../Components/NavBar";
import ReactHtmlParser from 'html-react-parser';
import ContentLoader from "react-content-loader";
import axios from "axios";
import Category from "../../Components/Category";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AccordionUsage from "../../Components/Poi/Accordin";

function CityView({ initialData = {}, language, currency }) {
  const navigate = useNavigate();
  const [category, setCategory] = useState(initialData?.page?.data || []);
  const [cities, setCities] = useState([]);
  const [cityData, setCityData] = useState(initialData?.city?.data?.city || {});
  const [load, setLoad] = useState(true);
  const [poi, setPoi] = useState(initialData.city?.data?.pois || []);
  const [catgeory, setcategory] = useState(initialData.page?.data || []);
  const [description, setDescription] = useState('');
  const [ar_description, setar_description] = useState('');
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [cityNotFound, setCityNotFound] = useState(false); // Add this state

  const location = useLocation()
  const cityId = location.pathname.match(/([a-f0-9]{24})/);
  console.log(initialData)

  useEffect(() => {
    if (!cityId) {
      console.error("cityId is not defined");
      setCityNotFound(true);
      setLoad(false);
      return;
    }

    const fetchCityData = async () => {
      if (initialData?.city?.data?.city) {
        setLoad(false);
        return;
      } else {
        try {
          const response = await axios.get(`https://admin.hopdays.com/api/single-city/${cityId[0]}?language=${language}`);
          
          // Check if city data exists
          if (!response.data?.data?.city || Object.keys(response.data.data.city).length === 0) {
            setCityNotFound(true);
          } else {
            setCityData(response.data.data.city);
            setPoi(response.data.data.pois);
            setCityNotFound(false);
          }
          
          setLoad(false);
        } catch (error) {
          console.error("Fetch Error:", error);
          setCityNotFound(true);
          setLoad(false);
        }
      }
    };

    fetchCityData();
  }, [cityId, initialData]);

  let lineHeight = "30px"
  let fontSize = "20px"
  let color = "#FFFFFF"
  
  useEffect(() => {
    setDescription(cityData.description);
    setar_description(cityData.ar_description);
  }, [cityData]);

  const styledDescription = description?.replace(
    /<span[^>]*>/g,
    `<span style="font-size: ${fontSize}; line-height: ${lineHeight}; color: ${color};">`
  );
  const sanitizedDescription = typeof styledDescription === 'string' ? styledDescription : '';

  const categoryId = "all"
  const handelExploreMore = () => {
    navigate(`/${language}all-poi/${categoryId}`); 
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  };

  function truncateText(text, wordLimit) {
    if (!text) return "";
    const words = text?.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  }

  // Universal loader component
  const UniversalLoader = () => (
    <div className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#5B27D5]"></div>
    </div>
  );

  // No City Found component
  const NoCityFound = () => (
    <div className="min-h-screen bg-gray-50">
      <NavBar language={language || Cookies.get("lang")} />
      <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
        <div className="text-center">
          <div className="mb-8">
            <svg className="mx-auto h-24 w-24 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {language === "ar" ? "المدينة غير موجودة" : "City Not Found"}
          </h1>
          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            {language === "ar" 
              ? "عذراً، لم نتمكن من العثور على المدينة المطلوبة. قد تكون غير متوفرة أو تم حذفها."
              : "Sorry, we couldn't find the city you're looking for. It may not be available or has been removed."}
          </p>
          <div className="space-y-4">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#5B27D5] hover:bg-[#9747FF] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5B27D5] transition-colors duration-300"
            >
              {language === "ar" ? "العودة للخلف" : "Go Back"}
            </button>
            <div className="text-center">
              <Link
                to={`/${language || 'en'}`}
                className="text-[#5B27D5] hover:text-[#9747FF] font-medium transition-colors duration-300"
              >
                {language === "ar" ? "العودة للصفحة الرئيسية" : "Return to Homepage"}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer language={language} />
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const DescriptionContent = ({ content, isArabic }) => {
    const [showReadMore, setShowReadMore] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
      if (content) {
        const words = content.split(/\s+/);
        const wordLimit = isMobile ? 20 : 80;
        setShowReadMore(words.length > wordLimit);
      }
    }, [content, isMobile]);

    const toggleExpand = () => {
      setIsDescriptionExpanded(prev => !prev);
    };

    const renderContent = () => {
      if (!content) return '';
      
      const words = content.split(/\s+/);
      const wordLimit = isMobile ? 20 : 80;
      
      if (!showReadMore || isDescriptionExpanded) {
        return content;
      }
      
      return words.slice(0, wordLimit).join(' ') + '...';
    };

    return (
      <div className="relative">
        <div 
          ref={contentRef}
          className="text-[20px] max-sm:text-[13px] leading-6 max-sm:leading-4 italic max-sm:ms-1"
        >
          {ReactHtmlParser(`<span className="override-html">${renderContent()}</span>`)}
        </div>
        {showReadMore && (
          <button
            onClick={toggleExpand}
            className={`mt-2 text-[#5B27D5] font-medium hover:text-[#9747FF] transition-colors duration-300 ${
              isArabic ? 'text-right' : 'text-left'
            }`}
          >
            {isDescriptionExpanded 
              ? (isArabic ? 'عرض أقل' : 'Show Less') 
              : (isArabic ? 'اقرأ المزيد' : 'Read More')}
          </button>
        )}
      </div>
    );
  };

  const formatTips = (tipsArray) => {
    if (!tipsArray || !Array.isArray(tipsArray)) return '';
    return tipsArray.map(tip => `<li>${tip}</li>`).join('');
  };

  // Return No City Found component if city is not found
  if (cityNotFound && !load) {
    return <NoCityFound />;
  }

  // Check if cityData is empty (additional safety check)
  if (!load && (!cityData || Object.keys(cityData).length === 0)) {
    return <NoCityFound />;
  }

  return (
    <>
      {load && <UniversalLoader />}
      <div>
        <div className="w-full">
          <NavBar language={language || Cookies.get("lang")}/>
          <div>
            <img className="h-[531px] max-sm:h-[400px] w-full" src={cityData?.image} />
          </div>

          <div className={`relative lg:bottom-[500px] max-sm:bottom-[100px] lg:ms-20 max-sm:ms-4 text-white ${language === "ar" ? "text-right" : "text-left"}`}>
            <p className={`mb-80 text-[13px] flex font-medium ${language === "ar" ? "rtl mr-5" : "text-left"} max-sm:hidden`}>
              {language === "ar"
                ? `${cityData?.ar_name || "اسم المدينة"} > ${cityData?.state?.ar_name || "الولاية"} > ${cityData?.country?.ar_name || "الدولة"}`
                : `${cityData?.country?.name || "Country"} > ${cityData?.state?.name || "State"} > ${cityData?.name || "City Name"}`}
            </p>

            <h1 className={`lg:text-[70px] max-sm:text-[40px] font-medium ${language === "ar" ? "text-right mr-5" : "text-left"}`} style={{ fontFamily: "inter" }}>
              {language === "ar" ? cityData?.ar_name || "اسم المدينة" : cityData?.name || "City Name"}
            </h1>

            <p style={{ marginBottom: "-90px" }} className={`mt-2 text-[20px] ${language === "ar" ? "text-right mr-5" : "text-left"}`}>
              {language === "ar"
                ? `${cityData?.state?.ar_name || "الولاية"} , ${cityData?.country?.ar_name || "الدولة"}`
                : `${cityData?.state?.name}, ${cityData?.country?.name || "country"}`}
            </p>
          </div>
        </div>

        <div className={` max-sm:flex-col ${language === "ar" ? " mr-4" : "flex-row"} max-sm:-mt-14 lg:-mt-96`}>
          <div className="text-center justify-center max-sm:w-[100%] lg:px-20 max-sm:px-5 mt-5 items-center max-sm:mt-16 w-[100%]">
            <div className={`${language === "ar" ? "text-center" : "text-center"}`}>
              <h1 className="italic max-sm:text-[20px] text-[40px] max-sm:font-medium">
                {language === "ar"
                  ? truncateText(cityData?.ar_blurb, 5)
                  : truncateText(cityData?.blurb, 5)}
              </h1>
              <DescriptionContent 
                content={language === "ar" 
                  ? cityData?.ar_description
                  : cityData?.description
                }
                isArabic={language === "ar"}
              />
            </div>
          </div>

          <div className={`flex overflow-x-scroll items-center lg:px-20 mt-5 max-sm:mt-10 gap-5 max-sm:gap-3 w-[100%] max-sm:w-[100%] max-sm:px-4 `}>
            <div className="lg:w-[100%] max-sm:w-[100%] max-sm:ml-1  lg:h-auto max-sm:h-auto rounded-xl  ">
              <div className={`${language === "ar" ? "text-right" : "text-left"}`}>
                <ul className="list-disc space-y-2">
                  {ReactHtmlParser(formatTips(language === "ar" ? cityData?.ar_tips : cityData?.tips))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div dir={language === "ar" ? "rtl" : "ltr"}>
          <div className="lg:py-2">
            <div className={`flex ${language === "ar" ? "items-end" : "items-start"} justify-between flex-wrap gap-4 ${language === "ar" ? "lg:px-20 max-sm:px-5" : "lg:px-20 max-sm:px-5"} mt-32 max-sm:mt-10`}>
              <div className="flex flex-col gap-1">
                <p className="text-[25px] max-sm:text-[16px] font-light">
                  {language === "ar" ? "استكشاف" : "Exploring"}
                </p>
                <p className="lg:text-[40px] max-sm:text-[20px] font-bold text-[#5B27D5]">
                  {language === "ar"
                    ? `${cityData?.ar_name}'s جمال`
                    : `${cityData?.name}'s Beauty`}
                </p>
              </div>
              <div className="lg:w-[40%] max-sm:w-full border-b border-black" />
              <div className={`${language === "ar" ? "flex flex-row-reverse max-sm:justify-end" : "flex max-sm:justify-start"} w-full lg:w-auto`}>
                <Link
                  to={`/${language}/all-poi/${categoryId}`}
                  className="border-2 border-black rounded-full font-semibold max-sm:text-[14px] max-sm:px-4 max-sm:py-1 px-7 py-1 hover:bg-[#9747FF] hover:border-white hover:text-white"
                >
                  {language === "ar" ? "اكتشف المزيد" : "Explore More"}
                  <ChevronRightIcon sx={{ fontSize: "18px" }} />
                </Link>
              </div>
            </div>

            <div className={`lg:w-[100%] max-sm:w-[100%] bg-gradient-to-b from-white via-[#f4f1cf] to-white flex ${language === "en" ? "lg:px-20 max-sm:px-5" : ""} lg:gap-10 max-sm:-space-x-5 overflow-y-hidden overscroll-x-contain overflow-x-scroll mt-5`}>
              {poi?.length > 0 ? (
                poi.map((i) => {
                  const city2 = i?.cityData?.name?.toLocaleLowerCase().replace(/\s+/g, '-');
                  const url = `${i.slug}-${i?.cityData?.name}-${i?.countryData?.name}-poi-${i._id}`;
                  const url2 = url.toLowerCase().replace(/\s+/g, '-');
                  const image = i.images[0];
                  const isArabic = language === "ar";
                  const navigateUrl = isArabic
                    ? `/ar/place/${city2}/${url2}`
                    : `/en/place/${city2}/${url2}`;
                  const title = isArabic ? i.ar_title : i.title;
                  const stateName = isArabic ? i?.stateData?.ar_name : i?.stateData?.name;
                  const description = isArabic
                    ? truncateText(i.ar_shortDescription, 10)
                    : truncateText(i.shortDescription, 130);

                  return (
                    <Link
                      to={navigateUrl}
                      key={i._id}
                      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                      className="lg:w-[404px] max-sm:w-[90%] flex-none mb-5 cursor-pointer"
                    >
                      <div>
                        <img
                          loading="lazy"
                          src={image}
                          alt={`${title} image`}
                          className="lg:w-[404px] lg:h-[280px] max-sm:w-[90%] max-sm:h-[200px] rounded-md hover:shadow-xl"
                        />
                      </div>
                      <div className="py-4">
                        <p className="text-[20px] max-sm:text-[15px]">
                          <b className="text-[22px] max-sm:text-[20px]">{title}, </b>
                          {stateName}
                        </p>
                        <div
                          className="lg:mt-5 max-sm:w-[90%] max-sm:mt-3 text-[17px] max-sm:text-[10px] lg:leading-5 max-sm:leading-3"
                          dangerouslySetInnerHTML={{
                            __html: `<span class="override-html">${truncateText(description, 30)}</span>`,
                          }}
                        ></div>
                      </div>
                    </Link>
                  );
                })
              ) : (
                <p className="py-5">
                  {language === "ar"
                    ? "لا توجد نقاط اهتمام متاحة."
                    : "No Points of Interest available."}
                </p>
              )}
            </div>

            <div className="lg:px-20 max-sm:px-5">
              <div className=" font-semibold text-[25px]  lg:mt-[70px] max-sm:mt-[30px] max-sm:text-[16px]">
                {language === "ar" ? "أشياء مهمة يجب معرفتها:" : "Important things to know :"}
              </div>
              {language === "ar" ?
                <div className="" >
                  <AccordionUsage qa={cityData?.ar_thingsToKnow} language={language} currency={currency}/>
                </div>
                :
                <div className="" >
                  <AccordionUsage qa={cityData?.thingsToKnow} language={language} currency={currency}/>
                </div>
              }
            </div>
          </div>
        </div>

        <div>
          <Category page={category} language={language} />
        </div>
      </div>
      <Footer language={language} />
    </>
  );
}

export default CityView;